/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

var proc = require( 'process' );


// MAIN //

/**
* Changes the current working directory.
*
* @param {string} path - desired working directory
* @returns {(Error|null)} error object
*
* @example
* var err = chdir( __dirname );
* if ( err ) {
*     throw err;
* }
*/
function chdir( path ) {
	try {
		proc.chdir( path );
	} catch ( err ) {
		return err;
	}
	return null;
}


// EXPORTS //

module.exports = chdir;
